// extracted by mini-css-extract-plugin
export default {"button":"styles_button__Y9tNX","back":"styles_back__9Qevf","ok":"styles_ok__8vWX9"};